module.exports = __webpack_public_path__ + "img/img1.1032def7.png";